import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enCommon from './locales/en/common.json';
import jaCommon from './locales/ja/common.json';
import enAuth from './locales/en/auth.json';
import jaAuth from './locales/ja/auth.json';
import enProjects from './locales/en/projects.json';
import jaProjects from './locales/ja/projects.json';
import enRequirements from './locales/en/requirements.json';
import jaRequirements from './locales/ja/requirements.json';
import enSys2 from './locales/en/sys2.json';
import jaSys2 from './locales/ja/sys2.json';
import enTestCases from './locales/en/testCases.json';
import jaTestCases from './locales/ja/testCases.json';
import enTestScripts from './locales/en/testScripts.json';
import jaTestScripts from './locales/ja/testScripts.json';
import enAdmin from './locales/en/admin.json';
import jaAdmin from './locales/ja/admin.json';
import enRequirementDoctor from './locales/en/requirement-doctor.json';
import jaRequirementDoctor from './locales/ja/requirement-doctor.json';
import enRequirementLifecycle from './locales/en/requirement-lifecycle.json';
import jaRequirementLifecycle from './locales/ja/requirement-lifecycle.json';
import enShell from './locales/en/shell.json';
import jaShell from './locales/ja/shell.json';
import enKnowledgeBase from './locales/en/knowledgeBase.json';
import jaKnowledgeBase from './locales/ja/knowledgeBase.json';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ja'],
    load: 'languageOnly',
    ns: [
      'common',
      'auth',
      'projects',
      'requirements',
      'sys2',
      'testCases',
      'testScripts',
      'admin',
      'requirement-doctor',
      'requirement-lifecycle',
      'shell',
      'knowledgeBase',
    ],
    defaultNS: 'common',
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        projects: enProjects,
        requirements: enRequirements,
        sys2: enSys2,
        testCases: enTestCases,
        testScripts: enTestScripts,
        admin: enAdmin,
        'requirement-doctor': enRequirementDoctor,
        'requirement-lifecycle': enRequirementLifecycle,
        shell: enShell,
        knowledgeBase: enKnowledgeBase,
      },
      ja: {
        common: jaCommon,
        auth: jaAuth,
        projects: jaProjects,
        requirements: jaRequirements,
        sys2: jaSys2,
        testCases: jaTestCases,
        testScripts: jaTestScripts,
        admin: jaAdmin,
        'requirement-doctor': jaRequirementDoctor,
        'requirement-lifecycle': jaRequirementLifecycle,
        shell: jaShell,
        knowledgeBase: jaKnowledgeBase,
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18next;

// Re-exported for existing consumers; see languageChangeQueue.ts for why the
// implementation lives in its own module.
export { queueLanguageChange } from './languageChangeQueue';
